import type {
    BeginCommerceEnrollmentRequest,
    BeginCommerceEnrollmentResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";
export const beginCommerceEnrollmentOperation: CommerceOperation<
    BeginCommerceEnrollmentRequest,
    BeginCommerceEnrollmentResponse
> = Object.freeze({ name: "commerce.enrollment.begin" });
